import { render, staticRenderFns } from "./ai_catalog_nav_tabs.vue?vue&type=template&id=6e93d4dc"
import script from "./ai_catalog_nav_tabs.vue?vue&type=script&lang=js"
export * from "./ai_catalog_nav_tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports